const HOST_MODE_MAP = {
  "oikosedu.com": "edu",
  "www.oikosedu.com": "edu",
  "oikosedu.app": "edu",
  "www.oikosedu.app": "edu",
  "church.oikos-software.com": "church",
  "oikoschurch.app": "church",
  "www.oikoschurch.app": "church",
  "oikoscampus.app": "campus",
  "www.oikoscampus.app": "campus",
  "oikossports.app": "sports",
  "www.oikossports.app": "sports",
  "oikosadmin.app": "admin",
  "www.oikosadmin.app": "admin",
};

const HOST_DEFAULT_PATH_MAP = {
  "oikosedu.com": "/edu/sales",
  "www.oikosedu.com": "/edu/sales",
  "oikosedu.app": "/devices/admin",
  "www.oikosedu.app": "/devices/admin",
  "oikoscampus.app": "/campus",
  "www.oikoscampus.app": "/campus",
};

const MODE_PATH_MAP = {
  home: "/home",
  business: "/business",
  edu: "/edu",
  pages: "/pages",
  nightstand: "/nightstand",
  church: "/church",
  admin: "/admin",
  campus: "/campus",
  sports: "/sports",
  farm: "/farm",
};

const OIKOS_CHURCH_SALES_HOSTS = new Set([
  "church.oikos-software.com",
  "oikoschurch.app",
  "www.oikoschurch.app",
]);

export function normalizeHostname(hostname = "") {
  return String(hostname).toLowerCase().trim();
}

export function isOikosChurchSalesHost(hostname = "") {
  return OIKOS_CHURCH_SALES_HOSTS.has(normalizeHostname(hostname));
}

export function getForcedModeForHostname(hostname = "") {
  return HOST_MODE_MAP[normalizeHostname(hostname)] || null;
}

export function getDefaultPathForMode(mode = "home") {
  return MODE_PATH_MAP[mode] || "/home";
}

export function getDefaultPathForHostname(hostname = "") {
  const normalizedHost = normalizeHostname(hostname);
  if (HOST_DEFAULT_PATH_MAP[normalizedHost]) return HOST_DEFAULT_PATH_MAP[normalizedHost];

  const forcedMode = getForcedModeForHostname(normalizedHost);
  return getDefaultPathForMode(forcedMode || "home");
}

export function resolveOriginalPath(explicitFrom, hostname = "", fallbackPath = "") {
  if (typeof explicitFrom === "string" && explicitFrom.trim()) {
    return explicitFrom;
  }

  if (typeof fallbackPath === "string" && fallbackPath.trim()) {
    return fallbackPath;
  }

  return getDefaultPathForHostname(hostname);
}
